import ContractSampleSelectDialog from "./ContractSampleSelectDialog";

const components = {
    ContractSampleSelectDialog,
    //
}

export default components